import FidelityListView from './FidelityListView';

const ListaFidelity = () => {
  return <FidelityListView title='Fidelity' />;
};

export default ListaFidelity;
